// @flow
import React from 'react';

type Props = {
  category: string,
  member: {
    emailPublic: string,
    telPublic: string,
    nom: string,
    numeroAffiliation: string,
    prenom: string
  }
};

const ContactRow = (props: Props) => (
  <React.Fragment>
    <li className="member">
      <p className="member__title ft-h4">{`${props.member.prenom} ${props.member.nom}`}</p>
      <p className="member__role ft-h6 ft-up">{props.category}</p>
      <p className="member__info">
        {props.member.emailPublic && (
          <a
            href={`mailto:${props.member.emailPublic}`}
            title={`Contacter ${props.member.nom} par email`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="icon icon-mail is-inline" />
            {props.member.emailPublic}
          </a>
        )}
        {props.member.telPublic && (
          <a
            href={`tel:${props.member.telPublic}`}
            title={`Contacter ${props.member.nom} par téléphone`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="icon icon-phone is-inline" />
            {props.member.telPublic}
          </a>
        )}
      </p>
    </li>
  </React.Fragment>
);

export default ContactRow;
